import { Routes, RouterModule } from '@angular/router';

// Components
import { ConfirmMailComponent } from './confirm-mail/confirmmail.component';
import { ForgotPasswordComponent } from './forgotpassword/forgotpassword.component';
import { LoginComponent } from '../../../app/main/authentication/login/login.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ResetPasswordComponent } from '../../../app/main/authentication/resetpassword/resetpassword.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { RecoverSecurityCodeComponent } from './confirm-recover-security-code/recoversecuritycode.component';

export const appRoutes: Routes = [
  {
    path: 'confirmemail',
    component: ConfirmMailComponent
  },
  {
    path: 'forgotpassword',
    component: ForgotPasswordComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'privacy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'resetpassword',
    component: ResetPasswordComponent
  },
  {
    path: 'recoversecuritycode',
    component: RecoverSecurityCodeComponent
  },
  {
    path: 'terms',
    component: TermsConditionComponent
  }
];
